import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Layouts
import PublicLayout from "../layouts/PublicLayout";
import AdminLayout from "../layouts/AdminLayout";
import EmployeeLayout from "../layouts/EmployeeLayout";

// Components
import { RequireAuth } from "../components/common/RequireAuth";

// Public Pages
import HomePage from "../pages/HomePage";
import AboutUsPage from "../pages/AboutUsPage";
import ServicePage from "../pages/ServicePage";
import ContactPage from "../pages/ContactPage";
import CareersPage from "../pages/CareersPage";
import BookNow from "../pages/BookNowPage";

// Auth & Admin/Employee Pages
import AuthPage from "../pages/auth/AuthPage";
import BookingManagementPage from "../pages/admin/BookingManagementPage";
import BookingEditPage from "../pages/admin/BookingEditPage";
import EmployeeManagementPage from "../pages/admin/EmployeeManagementPage";
import QuotationManagementAdmin from "../pages/admin/QuotationManagementPage";
import TimeManagementPage from "../pages/employee/TimeManagementPage";
import QuotationManagementEmployee from "../pages/employee/QuotationManagementPage";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<AboutUsPage />} />
        <Route path="/services" element={<ServicePage />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/book-now" element={<BookNow />} />
        <Route path="/careers" element={<CareersPage />} />
      </Route>

      {/* Auth Route */}
      <Route path="/auth" element={<AuthPage />} />

      {/* Admin Protected Routes */}
      <Route element={<RequireAuth allowedRoles={['admin']} />}>
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="booking-management" replace />} />
          <Route path="booking-management" element={<BookingManagementPage />} />
          <Route path="booking-management/edit/:id" element={<BookingEditPage />} />
          <Route path="employee-management" element={<EmployeeManagementPage />} />
          <Route path="quotation-management" element={<QuotationManagementAdmin />} />
        </Route>
      </Route>

      {/* Employee Protected Routes */}
      <Route element={<RequireAuth allowedRoles={['employee']} />}>
        <Route path="/employee" element={<EmployeeLayout />}>
          <Route index element={<Navigate to="time-management" replace />} />
          <Route path="time-management" element={<TimeManagementPage />} />
          <Route path="quotation-management" element={<QuotationManagementEmployee />} />
        </Route>
      </Route>
      
      {/* Catch all redirect to home or 404 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
